






















import Vue from "vue"
import Datatable, { DatatableOptions, IDatatable } from "@/components/datatable/Datatable.vue"
import { RangeOffice } from "@/model/entity/range-office/range-office"
import { IRangeOfficeService, rangeOfficeService } from "@/model/service/range/range-office-service"
import { FieldDescription } from "@/model/entity/field-descriptor"
import { saveAs } from "file-saver"

interface Data {
  rangeOfficeService: IRangeOfficeService
  options: DatatableOptions
  fields: FieldDescription[]
}

export default Vue.extend({
  components: { Datatable },
  data(): Data {
    return {
      rangeOfficeService: rangeOfficeService,
      options: {},
      fields: RangeOffice.getFieldDescriptionList()
    }
  },
  methods: {
    handleFileResponse(response: any) {
      const filename = response.headers["content-disposition"].match(/attachment; filename=(.*)/)[1]
      const contentType = response.headers["content-type"]
      const blob = new Blob([response.data], { type: contentType })
      saveAs(blob, filename)
    },
    exportFile() {
      const vm = this
      vm.startLoad()
      const datatable = this.$refs.datatable as any
      const queryParams = vm.rangeOfficeService.buildQueryParams(datatable.buildFilters())
      this.$http({
        method: "get",
        url: "/range_office/export/csv" + queryParams,
        responseType: "arraybuffer"
      }).then(response => {
        vm.endLoad()
        vm.handleFileResponse(response)
      })
        .catch(() => vm.endLoad())
    }
  }
})
